import React, { useEffect, useState } from 'react'

import { useT } from '../../i18n'
import { lotApi } from '../../utils/lotApi'
import { otherActiveLotsInUnit } from '../../utils/unitOccupancy'

// findings #104: warns (never blocks) when the chosen unit already holds
// another active lot. Loads that unit's lots itself: the lot form can target a
// facility other than the one the Lotes list shows.
export default function UnitOccupiedWarning({ farmId, unitId, excludeLotId }: {
  farmId: string
  unitId: string
  excludeLotId?: string
}): React.ReactElement | null {
  const t = useT()
  const [lotKeys, setLotKeys] = useState<string[]>([])

  useEffect(() => {
    if (!farmId || !unitId) {
      setLotKeys([])
      return
    }
    let cancelled = false
    void lotApi.list({ farmId, productionUnitId: unitId }, { preferLocal: true })
      .then((lots) => {
        if (!cancelled) setLotKeys(otherActiveLotsInUnit(lots, unitId, excludeLotId ? [excludeLotId] : []).map((lot) => lot.lotKey))
      })
      .catch(() => {
        if (!cancelled) setLotKeys([])
      })
    return () => {
      cancelled = true
    }
  }, [farmId, unitId, excludeLotId])

  if (lotKeys.length === 0) return null
  return (
    <div role="status" data-testid="lots-form-unit-occupied" style={{ fontSize: 12, fontWeight: 600, color: '#b45309' }}>
      {t('lots.unitOccupied.warning', { lots: lotKeys.join(', ') })}
    </div>
  )
}
